import turn14StoresApparelDefaults from '../bigcommerce-turn14-stores-apparel/config.js';

export default {
  includes: ['bigcommerce-turn14-stores-apparel'],
  ...turn14StoresApparelDefaults,
};
